export const vendorlist = [
  {
      "id": 316,
      "companyName": "GreenFields Agro Suppliers",
      "gstNumber": "14ADSDA7845A87C",
      "billAddress": "76 11 A St - Al Mizhar ",
      "billAddress2": "Al Mizhar 1 - Dubai - United Arab Emirates",
      "billAddress3": "360070",
      "shippingAddress": "76 11 A St - Al Mizhar ",
      "shippingAddress2": "Al Mizhar 1 - Dubai - United Arab Emirates",
      "shippingAddress3": "360070",
      "state": null,
      "accountHolderName": null,
      "bankName": null,
      "accountNumber": null,
      "panNumber": "ADSDA7845A",
      "ifscCode": null,
      "country": "Oman",
      "vendorCode": "1003",
      "termsOfPayment": "100% against Delivery.",
      "partyType": {
          "id": 151,
          "key": "Supplier",
          "label": "Dairy Suppliers",
          "description": "Dairy Suppliers",
          "isDeleted": false,
          "partner": {
              "id": 29,
              "name": "retail",
              "description": "retail",
              "isDeleted": false
          }
      },
      "partyTypeCategory": {
          "id": 54,
          "key": "Premium",
          "label": "Titanium Suppliers",
          "description": "Titanium Suppliers",
          "partyType": {
              "id": 153,
              "key": "Supplier",
              "label": "Packaging Suppliers",
              "description": "Packaging Suppliers",
              "isDeleted": false,
              "partner": {
                  "id": 29,
                  "name": "retail",
                  "description": "retail",
                  "isDeleted": false
              }
          },
          "isDeleted": false,
          "partner": {
              "id": 29,
              "name": "retail",
              "description": "retail",
              "isDeleted": false
          }
      },
      "contactDetails": [
          {
              "id": 308,
              "firstName": "Mukesh",
              "lastName": "Panday",
              "phoneNo": "1047859856",
              "altPhoneNo": null,
              "email": "mukesh@gmail.com",
              "designation": "Principle",
              "userName": null,
              "password": null,
              "experience": null,
              "title": null,
              "role": null
          }
      ],
      "isDeleted": false,
      "partner": {
          "id": 29,
          "name": "retail",
          "description": "retail",
          "isDeleted": false
      },
      "customerType": null,
      "name": null,
      "dob": null,
      "address": null,
      "mobileNo": null,
      "email": null,
      "identityType": null,
      "identityNo": null,
      "branchDetails": [],
      "owningCompany": null,
      "msmeNo": null,
      "cniNo": null,
      "designation": null,
      "type": null,
      "partyWebsite": null,
      "profession": null,
      "transports": [],
      "salesHead": [],
      "segment": null,
      "productTypes": [
          {
              "id": 88,
              "name": "Sauces and Marinades",
              "description": null,
              "partner": {
                  "id": 29,
                  "name": "retail",
                  "description": "retail",
                  "isDeleted": false
              },
              "isDeleted": false,
              "isPackingItemType": false,
              "productTypeItemProperties": [],
              "genericName": "Sauces and Marinades",
              "genericKey": 88
          },
          {
              "id": 95,
              "name": "Spices and Herbs",
              "description": null,
              "partner": {
                  "id": 29,
                  "name": "retail",
                  "description": "retail",
                  "isDeleted": false
              },
              "isDeleted": false,
              "isPackingItemType": false,
              "productTypeItemProperties": [],
              "genericName": "Spices and Herbs",
              "genericKey": 95
          }
      ],
      "partyDetails": {
          "id": 22,
          "score": 50,
          "insuranceDocs": [],
          "additionalInformation": []
      },
      "status": null
  },
  {
      "id": 315,
      "companyName": "QualityProducers Ltd.",
      "gstNumber": "23FDSFG4565G4HG",
      "billAddress": "Julnar Street ",
      "billAddress2": "Dubai - United Arab Emirates",
      "billAddress3": "300650",
      "shippingAddress": "Julnar Street ",
      "shippingAddress2": "Dubai - United Arab Emirates",
      "shippingAddress3": "300650",
      "state": null,
      "accountHolderName": null,
      "bankName": null,
      "accountNumber": null,
      "panNumber": "FDSFG4565G",
      "ifscCode": null,
      "country": "Kuwait",
      "vendorCode": "1002",
      "termsOfPayment": "100% against Delivery.",
      "partyType": {
          "id": 148,
          "key": "Supplier",
          "label": "Livestock Suppliers",
          "description": " Livestock Suppliers",
          "isDeleted": false,
          "partner": {
              "id": 29,
              "name": "retail",
              "description": "retail",
              "isDeleted": false
          }
      },
      "partyTypeCategory": {
          "id": 58,
          "key": "Gold",
          "label": "Crystal Suppliers",
          "description": "Crystal Suppliers",
          "partyType": {
              "id": 156,
              "key": "Supplier",
              "label": "Sauce and Condiment Suppliers",
              "description": "Sauce and Condiment Suppliers",
              "isDeleted": false,
              "partner": {
                  "id": 29,
                  "name": "retail",
                  "description": "retail",
                  "isDeleted": false
              }
          },
          "isDeleted": false,
          "partner": {
              "id": 29,
              "name": "retail",
              "description": "retail",
              "isDeleted": false
          }
      },
      "contactDetails": [
          {
              "id": 307,
              "firstName": "Mahehbhai",
              "lastName": "Jani",
              "phoneNo": "1021210121",
              "altPhoneNo": null,
              "email": "mahesh.jani@gmail.com",
              "designation": "principal",
              "userName": null,
              "password": null,
              "experience": null,
              "title": null,
              "role": null
          }
      ],
      "isDeleted": false,
      "partner": {
          "id": 29,
          "name": "retail",
          "description": "retail",
          "isDeleted": false
      },
      "customerType": null,
      "name": null,
      "dob": null,
      "address": null,
      "mobileNo": null,
      "email": null,
      "identityType": null,
      "identityNo": null,
      "branchDetails": [],
      "owningCompany": null,
      "msmeNo": null,
      "cniNo": null,
      "designation": null,
      "type": null,
      "partyWebsite": "www.diadubai.com",
      "profession": null,
      "transports": [],
      "salesHead": [],
      "segment": null,
      "productTypes": [
          {
              "id": 86,
              "name": "Beef Steaks",
              "description": null,
              "partner": {
                  "id": 29,
                  "name": "retail",
                  "description": "retail",
                  "isDeleted": false
              },
              "isDeleted": false,
              "isPackingItemType": false,
              "productTypeItemProperties": [],
              "genericName": "Beef Steaks",
              "genericKey": 86
          }
      ],
      "partyDetails": {
          "id": 18,
          "swiftCode": "swift1",
          "currency": "currency1",
          "ibanNo": "iban1",
          "companyName": "",
          "poBox": "",
          "telPhoneNo": "",
          "faxNo": "",
          "tradeLicence": "",
          "issuedAt": "",
          "issuedAuth": "",
          "trn": "",
          "holCompany": "",
          "foreignSupplier": "affiliation foreign supplier",
          "supplierFor": "Interior Materials,Landscape Materials",
          "scopeOfService": "Accident and Civil Responsibility Insurance,Accidents & Liabilities Insurance",
          "warranty": "Conditionally (only when requested)",
          "ehs": "true",
          "ehsIso": "true",
          "qaqc": "true",
          "qaIso": "true",
          "minContractValue": "100",
          "maxContractValue": "300",
          "insurance": "Professional Indemnity",
          "financialInfo": "true",
          "decConfIntre": "N/A",
          "currentlyEmployedWithUs": "true",
          "currentlyEmployedName": "Amazon",
          "currentlyEmployedDesignation": "designation",
          "currentlyEmployedPerFrom": "2023-06-22",
          "currentlyEmployedWithTo": "2023-06-30",
          "dispute": "true",
          "disNumInsta": "sdfsdf",
          "lastTwoProjecBond": "true",
          "undertaking": "true",
          "authSignatory": "auth",
          "authDesignation": "auth designation",
          "heavyEquipMach": "12",
          "lightEquipMach": "13",
          "ehsFileName": "https://erpv5.neofruition.co.in/file/get/https://erpv5.neofruition.co.in/file/get/1687193454502_partyaddupdatets.txt",
          "ehsIsoFileName": "https://erpv5.neofruition.co.in/file/get/https://erpv5.neofruition.co.in/file/get/1687193454506_vendordata.txt",
          "qaqcManualFileName": "https://erpv5.neofruition.co.in/file/get/https://erpv5.neofruition.co.in/file/get/1687193454506_partyaddupdatets.txt",
          "qaqcIsoManualFileName": "https://erpv5.neofruition.co.in/file/get/https://erpv5.neofruition.co.in/file/get/1687193454507_partyaddupdatehtml.txt",
          "score": 20,
          "insuranceDocs": [],
          "additionalInformation": [
              {
                  "id": 41,
                  "value": "port 1",
                  "key": "Airport"
              },
              {
                  "id": 42,
                  "value": "auth port 2",
                  "key": "Ports Authority"
              }
          ]
      },
      "status": null
  },
  {
      "id": 314,
      "companyName": "GoldenMeats Co.",
      "gstNumber": "24AAACO9200B3Z2",
      "billAddress": "Springs 3",
      "billAddress2": "Emirates Hills Dubai",
      "billAddress3": "37828",
      "shippingAddress": "Springs 3,",
      "shippingAddress2": "Emirates Hills Dubai",
      "shippingAddress3": "37828",
      "state": "Gujarat",
      "accountHolderName": null,
      "bankName": null,
      "accountNumber": null,
      "panNumber": "AAACO9200B",
      "ifscCode": null,
      "country": "Saudi Arabia",
      "vendorCode": "1001",
      "termsOfPayment": null,
      "partyType": {
          "id": 151,
          "key": "Supplier",
          "label": "Dairy Suppliers",
          "description": "Dairy Suppliers",
          "isDeleted": false,
          "partner": {
              "id": 29,
              "name": "retail",
              "description": "retail",
              "isDeleted": false
          }
      },
      "partyTypeCategory": null,
      "contactDetails": [
          {
              "id": 306,
              "firstName": "Tanmay",
              "lastName": "Vyas",
              "phoneNo": "9999999999",
              "altPhoneNo": null,
              "email": "tanmay@gmail.com",
              "designation": "Principle",
              "userName": null,
              "password": null,
              "experience": null,
              "title": null,
              "role": null
          }
      ],
      "isDeleted": false,
      "partner": {
          "id": 29,
          "name": "retail",
          "description": "retail",
          "isDeleted": false
      },
      "customerType": null,
      "name": null,
      "dob": null,
      "address": null,
      "mobileNo": null,
      "email": null,
      "identityType": null,
      "identityNo": null,
      "branchDetails": [],
      "owningCompany": null,
      "msmeNo": null,
      "cniNo": null,
      "designation": null,
      "type": null,
      "partyWebsite": "",
      "profession": null,
      "transports": [],
      "salesHead": [],
      "segment": null,
      "productTypes": [
          {
              "id": 98,
              "name": "Vegetable Oils",
              "description": null,
              "partner": {
                  "id": 29,
                  "name": "retail",
                  "description": "retail",
                  "isDeleted": false
              },
              "isDeleted": false,
              "isPackingItemType": false,
              "productTypeItemProperties": [],
              "genericName": "Vegetable Oils",
              "genericKey": 98
          },
          {
              "id": 96,
              "name": "Fresh Fruits and Vegetables",
              "description": null,
              "partner": {
                  "id": 29,
                  "name": "retail",
                  "description": "retail",
                  "isDeleted": false
              },
              "isDeleted": false,
              "isPackingItemType": false,
              "productTypeItemProperties": [],
              "genericName": "Fresh Fruits and Vegetables",
              "genericKey": 96
          }
      ],
      "partyDetails": {
          "id": 16,
          "swiftCode": "123123",
          "currency": "123123",
          "ibanNo": "123123",
          "companyName": "",
          "poBox": "",
          "telPhoneNo": "",
          "faxNo": "",
          "tradeLicence": "",
          "issuedAt": "",
          "issuedAuth": "",
          "trn": "",
          "holCompany": "",
          "foreignSupplier": "",
          "supplierFor": "Electrical Materials",
          "scopeOfService": "Accident and Civil Responsibility Insurance",
          "warranty": "Conditionally (only when requested)",
          "ehs": "true",
          "ehsIso": "true",
          "qaqc": "true",
          "qaIso": "true",
          "minContractValue": "4999",
          "maxContractValue": "5999",
          "insurance": "Professional Indemnity",
          "financialInfo": "true",
          "decConfIntre": "12312312",
          "currentlyEmployedWithUs": "true",
          "currentlyEmployedName": "Name",
          "currentlyEmployedDesignation": "Desig",
          "currentlyEmployedPerFrom": "2023-12-11",
          "currentlyEmployedWithTo": "2023-02-11",
          "dispute": "true",
          "lastTwoProjecBond": "true",
          "undertaking": "true",
          "authSignatory": "AAAA",
          "authDesignation": "BBBB",
          "heavyEquipMach": "12",
          "lightEquipMach": "13",
          "ehsFileName": "https://erpv5.neofruition.co.in/file/get/https://erpv5.neofruition.co.in/file/get/undefined",
          "ehsIsoFileName": "https://erpv5.neofruition.co.in/file/get/https://erpv5.neofruition.co.in/file/get/undefined",
          "qaqcManualFileName": "https://erpv5.neofruition.co.in/file/get/https://erpv5.neofruition.co.in/file/get/undefined",
          "qaqcIsoManualFileName": "https://erpv5.neofruition.co.in/file/get/https://erpv5.neofruition.co.in/file/get/undefined",
          "score": 10,
          "insuranceDocs": [],
          "additionalInformation": [
              {
                  "id": 37,
                  "value": "sdfdf",
                  "key": "Municipality"
              },
              {
                  "id": 38,
                  "value": "sdfsdf",
                  "key": "Electric and Water Authority"
              }
          ]
      },
      "status": null
  },
  {
      "id": 312,
      "companyName": "FarmFresh Foods",
      "gstNumber": "0707afdshcfer10",
      "billAddress": "202, Shanti kunj, Science City",
      "billAddress2": "Ahmedabad",
      "billAddress3": "380023",
      "shippingAddress": "202, Shanti kunj, Science City",
      "shippingAddress2": "Ahmedabad",
      "shippingAddress3": "380023",
      "state": "Gujarat",
      "accountHolderName": null,
      "bankName": null,
      "accountNumber": null,
      "panNumber": "07afdshcfe",
      "ifscCode": null,
      "country": "India",
      "vendorCode": "RFGR234",
      "termsOfPayment": null,
      "partyType": {
          "id": 147,
          "key": "Supplier",
          "label": "Farm Suppliers",
          "description": null,
          "isDeleted": false,
          "partner": {
              "id": 29,
              "name": "retail",
              "description": "retail",
              "isDeleted": false
          }
      },
      "partyTypeCategory": {
          "id": 55,
          "key": "Premium",
          "label": "Ruby Suppliers",
          "description": "Ruby Suppliers",
          "partyType": {
              "id": 150,
              "key": "Supplier",
              "label": "Fisheries and Seafood Suppliers",
              "description": "Fisheries and Seafood Supplier",
              "isDeleted": false,
              "partner": {
                  "id": 29,
                  "name": "retail",
                  "description": "retail",
                  "isDeleted": false
              }
          },
          "isDeleted": false,
          "partner": {
              "id": 29,
              "name": "retail",
              "description": "retail",
              "isDeleted": false
          }
      },
      "contactDetails": [
          {
              "id": 304,
              "firstName": "Tejas",
              "lastName": "Patel",
              "phoneNo": "9724386968",
              "altPhoneNo": null,
              "email": "tejas@gmail.com",
              "designation": "Head",
              "userName": null,
              "password": null,
              "experience": null,
              "title": null,
              "role": null
          }
      ],
      "isDeleted": false,
      "partner": {
          "id": 29,
          "name": "retail",
          "description": "retail",
          "isDeleted": false
      },
      "customerType": null,
      "name": null,
      "dob": null,
      "address": null,
      "mobileNo": null,
      "email": null,
      "identityType": null,
      "identityNo": null,
      "branchDetails": [],
      "owningCompany": null,
      "msmeNo": null,
      "cniNo": "20",
      "designation": null,
      "type": null,
      "partyWebsite": null,
      "profession": null,
      "transports": [],
      "salesHead": [],
      "segment": null,
      "productTypes": [
          {
              "id": 95,
              "name": "Spices and Herbs",
              "description": null,
              "partner": {
                  "id": 29,
                  "name": "retail",
                  "description": "retail",
                  "isDeleted": false
              },
              "isDeleted": false,
              "isPackingItemType": false,
              "productTypeItemProperties": [],
              "genericName": "Spices and Herbs",
              "genericKey": 95
          }
      ],
      "partyDetails": {
          "id": 20,
          "score": 35,
          "insuranceDocs": [],
          "additionalInformation": []
      },
      "status": null
  },
  {
      "id": 267,
      "companyName": "GlobalMeats Distributors",
      "gstNumber": "24AKXPT8674ASSC",
      "billAddress": "A 150, GIDC Area ",
      "billAddress2": "AHMEDABAD",
      "billAddress3": "320445",
      "shippingAddress": "A 150, GIDC Area ",
      "shippingAddress2": "AHMEDABAD",
      "shippingAddress3": "320445",
      "state": "Gujarat",
      "accountHolderName": null,
      "bankName": null,
      "accountNumber": null,
      "panNumber": "AKXPT8674A",
      "ifscCode": null,
      "country": "India",
      "vendorCode": null,
      "termsOfPayment": null,
      "partyType": {
          "id": 149,
          "key": "Supplier",
          "label": "Meat Processors",
          "description": "Meat Processors",
          "isDeleted": false,
          "partner": {
              "id": 29,
              "name": "retail",
              "description": "retail",
              "isDeleted": false
          }
      },
      "partyTypeCategory": {
          "id": 55,
          "key": "Premium",
          "label": "Ruby Suppliers",
          "description": "Ruby Suppliers",
          "partyType": {
              "id": 150,
              "key": "Supplier",
              "label": "Fisheries and Seafood Suppliers",
              "description": "Fisheries and Seafood Supplier",
              "isDeleted": false,
              "partner": {
                  "id": 29,
                  "name": "retail",
                  "description": "retail",
                  "isDeleted": false
              }
          },
          "isDeleted": false,
          "partner": {
              "id": 29,
              "name": "retail",
              "description": "retail",
              "isDeleted": false
          }
      },
      "contactDetails": [
          {
              "id": 259,
              "firstName": "Shreeji enterprise",
              "lastName": null,
              "phoneNo": "9856789045",
              "altPhoneNo": null,
              "email": "shreejient@yahoo.com",
              "designation": null,
              "userName": "vendor@HNY",
              "password": null,
              "experience": null,
              "title": null,
              "role": {
                  "roleid": 69,
                  "rolename": "VENDOR",
                  "isEmployee": null,
                  "webAccessAllowed": null,
                  "roleHasTarget": false,
                  "description": null,
                  "partner": {
                      "id": 1,
                      "name": "genericerpv4",
                      "description": "genericerpv4",
                      "isDeleted": false
                  },
                  "isDeleted": false
              }
          }
      ],
      "isDeleted": false,
      "partner": {
          "id": 29,
          "name": "retail",
          "description": "retail",
          "isDeleted": false
      },
      "customerType": null,
      "name": null,
      "dob": null,
      "address": null,
      "mobileNo": null,
      "email": null,
      "identityType": null,
      "identityNo": null,
      "branchDetails": [],
      "owningCompany": null,
      "msmeNo": null,
      "cniNo": "40",
      "designation": null,
      "type": null,
      "partyWebsite": null,
      "profession": null,
      "transports": [],
      "salesHead": [],
      "segment": null,
      "productTypes": [
          {
              "id": 97,
              "name": "Fresh Whole Chicken",
              "description": null,
              "partner": {
                  "id": 29,
                  "name": "retail",
                  "description": "retail",
                  "isDeleted": false
              },
              "isDeleted": false,
              "isPackingItemType": false,
              "productTypeItemProperties": [],
              "genericName": "Fresh Whole Chicken",
              "genericKey": 97
          },
          {
              "id": 85,
              "name": "Raw Poultry By-Products",
              "description": null,
              "partner": {
                  "id": 29,
                  "name": "retail",
                  "description": "retail",
                  "isDeleted": false
              },
              "isDeleted": false,
              "isPackingItemType": false,
              "productTypeItemProperties": [],
              "genericName": "Raw Poultry By-Products",
              "genericKey": 85
          },
          {
              "id": 1,
              "name": "Fresh Whole Poultry",
              "description": null,
              "partner": null,
              "isDeleted": false,
              "isPackingItemType": false,
              "productTypeItemProperties": [],
              "genericName": "Fresh Whole Poultry",
              "genericKey": 1
          }
      ],
      "partyDetails": {
          "id": 18,
          "swiftCode": "swift1",
          "currency": "currency1",
          "ibanNo": "iban1",
          "companyName": "",
          "poBox": "",
          "telPhoneNo": "",
          "faxNo": "",
          "tradeLicence": "",
          "issuedAt": "",
          "issuedAuth": "",
          "trn": "",
          "holCompany": "",
          "foreignSupplier": "affiliation foreign supplier",
          "supplierFor": "Interior Materials,Landscape Materials",
          "scopeOfService": "Accident and Civil Responsibility Insurance,Accidents & Liabilities Insurance",
          "warranty": "Conditionally (only when requested)",
          "ehs": "true",
          "ehsIso": "true",
          "qaqc": "true",
          "qaIso": "true",
          "minContractValue": "100",
          "maxContractValue": "300",
          "insurance": "Professional Indemnity",
          "financialInfo": "true",
          "decConfIntre": "N/A",
          "currentlyEmployedWithUs": "true",
          "currentlyEmployedName": "Amazon",
          "currentlyEmployedDesignation": "designation",
          "currentlyEmployedPerFrom": "2023-06-22",
          "currentlyEmployedWithTo": "2023-06-30",
          "dispute": "true",
          "disNumInsta": "sdfsdf",
          "lastTwoProjecBond": "true",
          "undertaking": "true",
          "authSignatory": "auth",
          "authDesignation": "auth designation",
          "heavyEquipMach": "12",
          "lightEquipMach": "13",
          "ehsFileName": "https://erpv5.neofruition.co.in/file/get/https://erpv5.neofruition.co.in/file/get/1687193454502_partyaddupdatets.txt",
          "ehsIsoFileName": "https://erpv5.neofruition.co.in/file/get/https://erpv5.neofruition.co.in/file/get/1687193454506_vendordata.txt",
          "qaqcManualFileName": "https://erpv5.neofruition.co.in/file/get/https://erpv5.neofruition.co.in/file/get/1687193454506_partyaddupdatets.txt",
          "qaqcIsoManualFileName": "https://erpv5.neofruition.co.in/file/get/https://erpv5.neofruition.co.in/file/get/1687193454507_partyaddupdatehtml.txt",
          "score": 20,
          "insuranceDocs": [],
          "additionalInformation": [
              {
                  "id": 41,
                  "value": "port 1",
                  "key": "Airport"
              },
              {
                  "id": 42,
                  "value": "auth port 2",
                  "key": "Ports Authority"
              }
          ]
      },
      "status": null
  },
  {
      "id": 266,
      "companyName": "PrimeProducers Ltd.",
      "gstNumber": "23ABOPK2285LOIK",
      "billAddress": "A/805, Ville Parle",
      "billAddress2": "Mumbai",
      "billAddress3": "420530",
      "shippingAddress": "A/805, Ville Parle",
      "shippingAddress2": "Mumbai",
      "shippingAddress3": "420530",
      "state": "Gujarat",
      "accountHolderName": null,
      "bankName": null,
      "accountNumber": null,
      "panNumber": "ABOPK2285L",
      "ifscCode": null,
      "country": "India",
      "vendorCode": null,
      "termsOfPayment": null,
      "partyType": {
          "id": 150,
          "key": "Supplier",
          "label": "Fisheries and Seafood Suppliers",
          "description": "Fisheries and Seafood Supplier",
          "isDeleted": false,
          "partner": {
              "id": 29,
              "name": "retail",
              "description": "retail",
              "isDeleted": false
          }
      },
      "partyTypeCategory": {
          "id": 55,
          "key": "Premium",
          "label": "Ruby Suppliers",
          "description": "Ruby Suppliers",
          "partyType": {
              "id": 150,
              "key": "Supplier",
              "label": "Fisheries and Seafood Suppliers",
              "description": "Fisheries and Seafood Supplier",
              "isDeleted": false,
              "partner": {
                  "id": 29,
                  "name": "retail",
                  "description": "retail",
                  "isDeleted": false
              }
          },
          "isDeleted": false,
          "partner": {
              "id": 29,
              "name": "retail",
              "description": "retail",
              "isDeleted": false
          }
      },
      "contactDetails": [
          {
              "id": 258,
              "firstName": "Nida Enterprise",
              "lastName": null,
              "phoneNo": "8923483477",
              "altPhoneNo": null,
              "email": "nidaent@gmail.com",
              "designation": null,
              "userName": "vendor@nida",
              "password": null,
              "experience": null,
              "title": null,
              "role": {
                  "roleid": 69,
                  "rolename": "VENDOR",
                  "isEmployee": null,
                  "webAccessAllowed": null,
                  "roleHasTarget": false,
                  "description": null,
                  "partner": {
                      "id": 1,
                      "name": "genericerpv4",
                      "description": "genericerpv4",
                      "isDeleted": false
                  },
                  "isDeleted": false
              }
          }
      ],
      "isDeleted": false,
      "partner": {
          "id": 29,
          "name": "retail",
          "description": "retail",
          "isDeleted": false
      },
      "customerType": null,
      "name": null,
      "dob": null,
      "address": null,
      "mobileNo": null,
      "email": null,
      "identityType": null,
      "identityNo": null,
      "branchDetails": [],
      "owningCompany": null,
      "msmeNo": null,
      "cniNo": "40",
      "designation": null,
      "type": null,
      "partyWebsite": null,
      "profession": null,
      "transports": [],
      "salesHead": [],
      "segment": null,
      "productTypes": [
          {
              "id": 87,
              "name": "Frozen Fish Fillets",
              "description": "",
              "partner": {
                  "id": 29,
                  "name": "retail",
                  "description": "retail",
                  "isDeleted": false
              },
              "isDeleted": false,
              "isPackingItemType": false,
              "productTypeItemProperties": [],
              "genericName": "Frozen Fish Fillets",
              "genericKey": 87
          }
      ],
      "partyDetails": {
          "id": 23,
          "score": 40,
          "insuranceDocs": [],
          "additionalInformation": []
      },
      "status": null
  },
  {
      "id": 265,
      "companyName": "PremiumProtein Suppliers",
      "gstNumber": "23ABOPK2249N1ZB",
      "billAddress": "B-190, GIDC Estate",
      "billAddress2": "Vadodara",
      "billAddress3": "369990",
      "shippingAddress": "B-190, GIDC Estate",
      "shippingAddress2": "Vadodara",
      "shippingAddress3": "369990",
      "state": "Gujarat",
      "accountHolderName": null,
      "bankName": null,
      "accountNumber": null,
      "panNumber": "ABOPK2249N",
      "ifscCode": null,
      "country": "India",
      "vendorCode": null,
      "termsOfPayment": null,
      "partyType": {
          "id": 156,
          "key": "Supplier",
          "label": "Sauce and Condiment Suppliers",
          "description": "Sauce and Condiment Suppliers",
          "isDeleted": false,
          "partner": {
              "id": 29,
              "name": "retail",
              "description": "retail",
              "isDeleted": false
          }
      },
      "partyTypeCategory": {
          "id": 56,
          "key": "Gold",
          "label": "Emerald Suppliers",
          "description": "Emerald Suppliers",
          "partyType": {
              "id": 151,
              "key": "Supplier",
              "label": "Dairy Suppliers",
              "description": "Dairy Suppliers",
              "isDeleted": false,
              "partner": {
                  "id": 29,
                  "name": "retail",
                  "description": "retail",
                  "isDeleted": false
              }
          },
          "isDeleted": false,
          "partner": {
              "id": 29,
              "name": "retail",
              "description": "retail",
              "isDeleted": false
          }
      },
      "contactDetails": [
          {
              "id": 257,
              "firstName": "PrimeProducers Ltd.",
              "lastName": null,
              "phoneNo": "8923483477",
              "altPhoneNo": null,
              "email": "sanjeevanidistributor@gmail.com",
              "designation": null,
              "userName": "vendor@sanjeevani",
              "password": null,
              "experience": null,
              "title": null,
              "role": {
                  "roleid": 69,
                  "rolename": "VENDOR",
                  "isEmployee": null,
                  "webAccessAllowed": null,
                  "roleHasTarget": false,
                  "description": null,
                  "partner": {
                      "id": 1,
                      "name": "genericerpv4",
                      "description": "genericerpv4",
                      "isDeleted": false
                  },
                  "isDeleted": false
              }
          }
      ],
      "isDeleted": false,
      "partner": {
          "id": 29,
          "name": "retail",
          "description": "retail",
          "isDeleted": false
      },
      "customerType": null,
      "name": null,
      "dob": null,
      "address": null,
      "mobileNo": null,
      "email": null,
      "identityType": null,
      "identityNo": null,
      "branchDetails": [],
      "owningCompany": null,
      "msmeNo": null,
      "cniNo": "40",
      "designation": null,
      "type": null,
      "partyWebsite": null,
      "profession": null,
      "transports": [],
      "salesHead": [],
      "segment": null,
      "productTypes": [
          {
              "id": 88,
              "name": "Sauces and Marinades",
              "description": null,
              "partner": {
                  "id": 29,
                  "name": "retail",
                  "description": "retail",
                  "isDeleted": false
              },
              "isDeleted": false,
              "isPackingItemType": false,
              "productTypeItemProperties": [],
              "genericName": "Sauces and Marinades",
              "genericKey": 88
          }
      ],
      "partyDetails": {
          "id": 22,
          "score": 50,
          "insuranceDocs": [],
          "additionalInformation": []
      },
      "status": null
  },
  {
      "id": 264,
      "companyName": "QualityLivestock Farms",
      "gstNumber": "24AKXPT8690A1ZI",
      "billAddress": "A 150, GIDC Area , Metoda ",
      "billAddress2": "Ahmedabad",
      "billAddress3": "360552",
      "shippingAddress": "A 150, GIDC Area , Metoda ",
      "shippingAddress2": "Ahmedabad",
      "shippingAddress3": "360552",
      "state": "Gujarat",
      "accountHolderName": null,
      "bankName": null,
      "accountNumber": null,
      "panNumber": "AKXPT8690A",
      "ifscCode": null,
      "country": "India",
      "vendorCode": "HNY01",
      "termsOfPayment": null,
      "partyType": {
          "id": 149,
          "key": "Supplier",
          "label": "Meat Processors",
          "description": "Meat Processors",
          "isDeleted": false,
          "partner": {
              "id": 29,
              "name": "retail",
              "description": "retail",
              "isDeleted": false
          }
      },
      "partyTypeCategory": {
          "id": 54,
          "key": "Premium",
          "label": "Titanium Suppliers",
          "description": "Titanium Suppliers",
          "partyType": {
              "id": 153,
              "key": "Supplier",
              "label": "Packaging Suppliers",
              "description": "Packaging Suppliers",
              "isDeleted": false,
              "partner": {
                  "id": 29,
                  "name": "retail",
                  "description": "retail",
                  "isDeleted": false
              }
          },
          "isDeleted": false,
          "partner": {
              "id": 29,
              "name": "retail",
              "description": "retail",
              "isDeleted": false
          }
      },
      "contactDetails": [
          {
              "id": 256,
              "firstName": "HNY Bake house",
              "lastName": null,
              "phoneNo": "9856789045",
              "altPhoneNo": null,
              "email": "ashanfoods@gmail.com",
              "designation": null,
              "userName": "vendor@vora",
              "password": null,
              "experience": null,
              "title": null,
              "role": {
                  "roleid": 69,
                  "rolename": "VENDOR",
                  "isEmployee": null,
                  "webAccessAllowed": null,
                  "roleHasTarget": false,
                  "description": null,
                  "partner": {
                      "id": 1,
                      "name": "genericerpv4",
                      "description": "genericerpv4",
                      "isDeleted": false
                  },
                  "isDeleted": false
              }
          }
      ],
      "isDeleted": false,
      "partner": {
          "id": 29,
          "name": "retail",
          "description": "retail",
          "isDeleted": false
      },
      "customerType": null,
      "name": null,
      "dob": null,
      "address": null,
      "mobileNo": null,
      "email": null,
      "identityType": null,
      "identityNo": null,
      "branchDetails": [],
      "owningCompany": null,
      "msmeNo": null,
      "cniNo": "30",
      "designation": null,
      "type": null,
      "partyWebsite": null,
      "profession": null,
      "transports": [],
      "salesHead": [],
      "segment": null,
      "productTypes": [
          {
              "id": 97,
              "name": "Fresh Whole Chicken",
              "description": null,
              "partner": {
                  "id": 29,
                  "name": "retail",
                  "description": "retail",
                  "isDeleted": false
              },
              "isDeleted": false,
              "isPackingItemType": false,
              "productTypeItemProperties": [],
              "genericName": "Fresh Whole Chicken",
              "genericKey": 97
          },
          {
              "id": 1,
              "name": "Fresh Whole Poultry",
              "description": null,
              "partner": null,
              "isDeleted": false,
              "isPackingItemType": false,
              "productTypeItemProperties": [],
              "genericName": "Fresh Whole Poultry",
              "genericKey": 1
          },
          {
              "id": 86,
              "name": "Beef Steaks",
              "description": null,
              "partner": {
                  "id": 29,
                  "name": "retail",
                  "description": "retail",
                  "isDeleted": false
              },
              "isDeleted": false,
              "isPackingItemType": false,
              "productTypeItemProperties": [],
              "genericName": "Beef Steaks",
              "genericKey": 86
          },
          {
              "id": 85,
              "name": "Raw Poultry By-Products",
              "description": null,
              "partner": {
                  "id": 29,
                  "name": "retail",
                  "description": "retail",
                  "isDeleted": false
              },
              "isDeleted": false,
              "isPackingItemType": false,
              "productTypeItemProperties": [],
              "genericName": "Raw Poultry By-Products",
              "genericKey": 85
          }
      ],
      "partyDetails": {
          "id": 21,
          "score": 25,
          "insuranceDocs": [],
          "additionalInformation": []
      },
      "status": null
  },
  {
      "id": 263,
      "companyName": "FreshHarvest Foods",
      "gstNumber": "24AKXPT8645LKSE",
      "billAddress": "A 150, GIDC Area , Metoda ",
      "billAddress2": "Ahmedabad",
      "billAddress3": "360552",
      "shippingAddress": "A 150, GIDC Area , Metoda ",
      "shippingAddress2": "Ahmedabad",
      "shippingAddress3": "360552",
      "state": "Gujarat",
      "accountHolderName": null,
      "bankName": null,
      "accountNumber": null,
      "panNumber": "AKXPT8645L",
      "ifscCode": null,
      "country": "India",
      "vendorCode": "Vendor/Ashan/01",
      "termsOfPayment": null,
      "partyType": {
          "id": 150,
          "key": "Supplier",
          "label": "Fisheries and Seafood Suppliers",
          "description": "Fisheries and Seafood Supplier",
          "isDeleted": false,
          "partner": {
              "id": 29,
              "name": "retail",
              "description": "retail",
              "isDeleted": false
          }
      },
      "partyTypeCategory": {
          "id": 54,
          "key": "Premium",
          "label": "Titanium Suppliers",
          "description": "Titanium Suppliers",
          "partyType": {
              "id": 153,
              "key": "Supplier",
              "label": "Packaging Suppliers",
              "description": "Packaging Suppliers",
              "isDeleted": false,
              "partner": {
                  "id": 29,
                  "name": "retail",
                  "description": "retail",
                  "isDeleted": false
              }
          },
          "isDeleted": false,
          "partner": {
              "id": 29,
              "name": "retail",
              "description": "retail",
              "isDeleted": false
          }
      },
      "contactDetails": [
          {
              "id": 255,
              "firstName": "Ashan food products",
              "lastName": null,
              "phoneNo": "9856789045",
              "altPhoneNo": null,
              "email": "ashanfoods@gmail.com",
              "designation": null,
              "userName": "ashan",
              "password": null,
              "experience": null,
              "title": null,
              "role": {
                  "roleid": 69,
                  "rolename": "VENDOR",
                  "isEmployee": null,
                  "webAccessAllowed": null,
                  "roleHasTarget": false,
                  "description": null,
                  "partner": {
                      "id": 1,
                      "name": "genericerpv4",
                      "description": "genericerpv4",
                      "isDeleted": false
                  },
                  "isDeleted": false
              }
          }
      ],
      "isDeleted": false,
      "partner": {
          "id": 29,
          "name": "retail",
          "description": "retail",
          "isDeleted": false
      },
      "customerType": null,
      "name": null,
      "dob": null,
      "address": null,
      "mobileNo": null,
      "email": null,
      "identityType": null,
      "identityNo": null,
      "branchDetails": [],
      "owningCompany": null,
      "msmeNo": null,
      "cniNo": "20",
      "designation": null,
      "type": null,
      "partyWebsite": null,
      "profession": null,
      "transports": [],
      "salesHead": [],
      "segment": null,
      "productTypes": [
          {
              "id": 87,
              "name": "Frozen Fish Fillets",
              "description": "",
              "partner": {
                  "id": 29,
                  "name": "retail",
                  "description": "retail",
                  "isDeleted": false
              },
              "isDeleted": false,
              "isPackingItemType": false,
              "productTypeItemProperties": [],
              "genericName": "Frozen Fish Fillets",
              "genericKey": 87
          }
      ],
      "partyDetails": {
          "id": 20,
          "score": 35,
          "insuranceDocs": [],
          "additionalInformation": []
      },
      "status": "Pending"
  }
];